export default __webpack_public_path__ + "static/media/levelTest-Illustration09.9e457718.jpg";